var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGearFilled20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Cloud/20/Gear",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.2,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.501 2.5c.552 0 1.07.45 1.157.99l.214 1.337a5.494 5.494 0 011.67.965l1.266-.483a1.209 1.209 0 011.437.507l.5.868c.276.478.147 1.152-.278 1.497l-1.051.855a5.534 5.534 0 010 1.928l1.05.855c.43.349.558 1.015.28 1.497l-.501.868c-.276.478-.925.703-1.437.507l-1.266-.483a5.494 5.494 0 01-1.67.965l-.214 1.337c-.087.547-.6.99-1.157.99H9.499c-.552 0-1.071-.45-1.158-.99l-.214-1.337a5.494 5.494 0 01-1.669-.965l-1.266.483a1.209 1.209 0 01-1.437-.507l-.5-.868c-.277-.478-.147-1.152.278-1.497l1.051-.854a5.534 5.534 0 010-1.929l-1.05-.855a1.209 1.209 0 01-.28-1.497l.501-.868c.276-.478.925-.703 1.437-.507l1.266.483a5.494 5.494 0 011.669-.965L8.34 3.49a1.21 1.21 0 011.158-.99H10.5zM10 7.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5z",
    id: "Combined-Shape",
    stroke: "currentColor",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearFilled20);
export default __webpack_public_path__ + "static/media/gear-filled-20.b6e8f95d.svg";
export { ForwardRef as ReactComponent };